import { Injectable } from '@angular/core';
import {Person} from "../../interfaces/person";
import {BehaviorSubject, Subscription} from "rxjs";
import {SEARCH_ACTIVE_EMPLOYEES} from "../employee-search/graphql/employee-search";
import {Apollo} from "apollo-angular";
import Role from "../../interfaces/role";
import {GET_FUND_ROLES} from "./graphql/analyst-search";

@Injectable({
  providedIn: 'root'
})
export class AnalystSearchService {
  private _people: Person[] = [];
  private people = new BehaviorSubject(this._people);
  public people$ = this.people.asObservable();

  private _loading = false;
  private loading = new BehaviorSubject(this._loading);
  public loading$ = this.loading.asObservable();
  private analystRoles: String[] = []
  constructor(private apollo: Apollo) {
    let sub = this.apollo.query({
      query: GET_FUND_ROLES,
      variables: {
        role: 'CREA Fund'
      }
    }).subscribe((result:any) => {
      let roles = result.data.roles_by_role_type_name.roles
      roles.forEach((role:Role) => {
        if(role.name.toLowerCase().includes('syndications')){
          this.analystRoles.push(role.name)
        }
      })
      sub?.unsubscribe()
    })
  }

  private _setPeople(people: Person[]){
    this._people = people;
    this.people.next(this._people);
  }
  private _setLoading(loading: boolean){
    this._loading = loading;
    this.loading.next(this._loading);
  }

  public searchPeople(name:string){
    let sub: Subscription;
    this._setLoading(true);
    sub = this.apollo
      .query({query:SEARCH_ACTIVE_EMPLOYEES, variables:{name: `%${name}%`}})
      .subscribe(({data})=>{
        this._setLoading(false);
        if(data?.search_active_employees) {
          let filteredEmployees:any[] = []
          for(let p = 0; p < data.search_active_employees.length; p++){
            let person = data.search_active_employees[p]
            for(let e = 0; e < person.entity.entity_types.length; e++){
              if(this.analystRoles.includes(person.entity.entity_types[e].type.name) && !filteredEmployees.includes(person)){
                filteredEmployees.push(person)
              }
            }
          }
          this._setPeople(filteredEmployees);
        }
        sub?.unsubscribe();
      });
  }
}
